'use strict';

import angular from 'angular';

import modalDirective from '../rest-modal';

import addFilterTemplate from './add-filter.html';

const MODULE_NAME = 'daupler.incidents.compnents.buttons.pumpStations';

var app = angular.module(MODULE_NAME, [
	'brg.components.inputs',
]);

app.directive('addWichitaPumpStationsFilter', modalDirective({
	template: addFilterTemplate,
	controller: function($http, $scope, toastr) {
		'ngInject';
		$scope.filter = {
			alarm: $scope.$context.entry.data.alarm,
			station: $scope.$context.entry.data.station,
			description: $scope.$context.entry.data.description,
			event: $scope.$context.entry.data.event,
		}
		$scope.station = 'restrict';
		$scope.description = 'restrict';
		$scope.event = 'restrict';
		$scope.toggle = function(name) {
			if ($scope[name] == 'restrict') {
				$scope.filter[name] = $scope.$context.entry.data[name];
			} else {
				delete $scope.filter[name];
			}
		}
		$scope.save = function() {
			$http.post('/wichita_pump_stations/add-filter/', {
				incident: $scope.$incident.uuid,
				filter: $scope.filter,
			}).then(function success() {
				toastr.success('Incident archived and filter added!');
				$scope.$dismiss();
			}, function error() {
				toastr.error('Failed to add filter.');
			});
		}
	},
}));

export default MODULE_NAME;
